export default (value: number | string) => {
  if (value) {
    return Math.ceil(+value)
  }
}